import React, { useState, useEffect } from 'react';
import Select from 'react-select';

export function SelectInput(props)
{
    return (
	<>
	    <Select styles={{
			option: (base, state) => {
			    return { ...base,
				     color: state.isFocused ? 'black' : 'white' }
			},
			menu: function(base, state)
			{
			    return {
				...base,
				'z-index': 10,
				background: 'var(--bs-gray)'
			    }
			}}}
		    {...props}/>
	</>
    )
}
